// DP236 — read a project name and a day out of what was typed on the capture line.
const DAYS = ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'];
const SHORT = ['sun', 'mon', 'tue', 'wed', 'thu', 'fri', 'sat'];

function key(d) { return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`; }

export function parseCapture(text, projects = []) {
  let title = String(text || '').trim();
  let project_id = null;
  let due_date = null;
  const lower = title.toLowerCase();
  // project: the first word of a project's name (4+ letters), or "name:" prefix
  for (const p of projects) {
    const first = String(p.name || '').split(/\s+/)[0] || '';
    if (first.length >= 4 && new RegExp(`(^|\\s)${first.toLowerCase()}(:|\\s|$)`).test(lower)) {
      project_id = p.id;
      title = title.replace(new RegExp(`(^|\\s)${first}:?(\\s|$)`, 'i'), ' ').trim();
      break;
    }
  }
  const today = new Date(); today.setHours(0, 0, 0, 0);
  const m = title.toLowerCase().match(/(^|\s)(today|tomorrow|next week|sunday|monday|tuesday|wednesday|thursday|friday|saturday|sun|mon|tue|wed|thu|fri|sat)(\s|$)/);
  if (m) {
    const w = m[2];
    const d = new Date(today);
    if (w === 'tomorrow') d.setDate(d.getDate() + 1);
    else if (w === 'next week') d.setDate(d.getDate() + ((8 - d.getDay()) % 7 || 7));
    else if (w !== 'today') {
      const idx = DAYS.indexOf(w) >= 0 ? DAYS.indexOf(w) : SHORT.indexOf(w);
      let diff = (idx - d.getDay() + 7) % 7; if (diff === 0) diff = 7;
      d.setDate(d.getDate() + diff);
    }
    due_date = key(d);
    title = title.replace(new RegExp(`(^|\\s)${w}(\\s|$)`, 'i'), ' ').replace(/\s{2,}/g, ' ').trim();
  }
  return { title, project_id, due_date };
}
